var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"unknown-error-page"},[_c('alert-page',{attrs:{"emoji":'🤦‍♂️',"title":'משהו לא עובד כרגע...',"showButton":false},scopedSlots:_vm._u([{key:"content",fn:function(){return [_vm._v("\n        אפשר לנסות לרענן את העמוד או לחזור שוב מאוחר יותר.\n    ")]},proxy:true}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ee755ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/general-errors/ServerError.vue
// module id = null
// module chunks = 